import React from "react";
import { useParams } from "react-router-dom";
import { useInquiryById } from "../../../../../api/inquiries/1on1-inquiry/use-1on1-inquiry-detail";
import TitlePage from "../../../../../components/section/TitlePage/Titlepage";
import Tabs, { Tablist } from "../../../../../components/ui/Tabs/Tabs";

import DetailItem from "./DetailItem";

const tabs = [
  {
    title: "병원 정보",
    id: 1,
  },
  {
    title: "환자 목록",
    id: 2,
  },
  {
    title: "주문내역",
    id: 3,
  },
  {
    title: "포인트",
    id: 4,
  },
  {
    title: "1:1 문의",
    id: 5,
  },
  {
    title: "상품 문의",
    id: 6,
  },
  {
    title: "주문내역",
    id: 7,
  },
];

const InquiryDetailPage = () => {
  const { id } = useParams();
  const { data } = useInquiryById(id);
  const inquiryData = data?.data;
  const [currentTab, setCurrentTab] = React.useState(5);

  const onChangeTab = (id) => {
    setCurrentTab(id);
  };

  return (
    <div>
      <TitlePage title="1:1 문의 > 1:1 문의 상세" />
      <Tabs
        tabWidth="w-20"
        onChangeTab={onChangeTab}
        currentTab={currentTab}
        tabs={tabs}
        isDisabled
      >
        <Tablist currentTab={currentTab} index={1}></Tablist>
        <Tablist currentTab={currentTab} index={2}></Tablist>
        <Tablist currentTab={currentTab} index={3}></Tablist>
        <Tablist currentTab={currentTab} index={4}></Tablist>
        <Tablist currentTab={currentTab} index={5}>
          <DetailItem data={inquiryData} />
        </Tablist>
        <Tablist currentTab={currentTab} index={6}></Tablist>
      </Tabs>
    </div>
  );
};

export default InquiryDetailPage;
